import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { UiService } from '../services/ui.service'
import { ApiService } from '../services/api.service'
import { handleArpioError } from 'src/utils/handle-error'

export interface NavigationState {
  rapidRefreshExpires: Date
  delayRapidRefresh: boolean
  forceRefreshResources?: boolean
  // When true, the application component shows an optimistic "Planning backup..." status
  // to bridge the latency gap between editor save and the backend starting the backup.
  expectBackupAfterSave?: boolean
}

@Injectable({
  providedIn: 'root',
})
export class ApplicationFormBaseService {
  constructor(
    private router: Router,
    private uiService: UiService,
    private apiService: ApiService
  ) {}

  createNavigationState(expectBackupAfterSave: boolean = false): NavigationState {
    return {
      rapidRefreshExpires: new Date(Date.now() + 60000),
      delayRapidRefresh: true,
      forceRefreshResources: true,
      expectBackupAfterSave,
    }
  }

  navigateToApplication(accountId: string, applicationId: string, expectBackupAfterSave: boolean = false): void {
    const state = this.createNavigationState(expectBackupAfterSave)
    this.router.navigateByUrl(this.uiService.buildApplicationUrl(accountId, applicationId), { state })
  }

  handleSaveError() {
    return handleArpioError(window.location.href, this.apiService, this.uiService)
  }
}
